<template>
  <nav aria-label="breadcrumb">
    <ol class="px-0 pt-1 pb-0 mb-0 bg-transparent breadcrumb">
      <li class="text-xs breadcrumb-item text-dark-gradient-state">
        <router-link class="opacity-8" to="/private/dashboard">Home</router-link> / {{ currentPage }}
      </li>
      <li class="text-lg breadcrumb-item active text-dark" aria-current="page">
        {{ currentPage }}
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  props: {
    currentPage: {
      required: true
    }
  }
};
</script>
